module.exports = __webpack_public_path__ + "img/b-3.2ad90d29.jpg";